<template>
  <v-chip
    class="mr-1 text-capitalize font-weight-bold"
    :class="$helper.getOrderStatusColor(params.data.status, true)"
    x-small
    v-if="params && params.data && params.data.verbose_status"
  >
    {{ params.data.verbose_status }}
  </v-chip>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
.ag-ltr .ag-cell {
  display: flex;
  align-items: center;
}
.v-chip .v-avatar {
  height: 10px !important;
  min-width: 10px !important;
  width: 10px !important;
}
</style>